export default __webpack_public_path__ + "static/media/upload-img.79024358.png";